import type { FC } from 'react';

import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';

import { DeepQueryHint } from '../DeepQueryHint';
import { SearchResultSummary } from '../SearchResultSummary';

export const SearchResultHeaderFragment = graphql(/* GraphQL */ `
  fragment SearchResultHeaderFragment on SuccessfulSearchResult {
    summary {
      totalResultCount
    }
    failureMode {
      ... on DeepQuery {
        alternateQuery
      }
      ... on QueryReduction {
        ignoredTokens
      }
    }
  }
`);

export type SearchResultHeaderProps = {
  maskedData: FragmentType<typeof SearchResultHeaderFragment>;
  /** the original search query */
  originalQuery: string;
};

/**
 * SearchResultHeader component description displayed in storybook
 * */
export const SearchResultHeader: FC<SearchResultHeaderProps> = ({ maskedData, originalQuery }) => {
  const {
    summary: { totalResultCount },
    failureMode,
  } = getFragmentData(SearchResultHeaderFragment, maskedData);

  // eslint-disable-next-line no-underscore-dangle
  return failureMode?.__typename === 'DeepQuery' ? (
    <DeepQueryHint count={totalResultCount} query={originalQuery} />
  ) : (
    <SearchResultSummary
      count={totalResultCount}
      query={originalQuery}
      // eslint-disable-next-line no-underscore-dangle
      isQueryReduction={failureMode?.__typename === 'QueryReduction'}
      ignoredSearchTerms={
        // eslint-disable-next-line no-underscore-dangle
        failureMode?.__typename === 'QueryReduction' ? failureMode.ignoredTokens : []
      }
    />
  );
};
